/* Foucault · Conversión y confianza (v5.1, 24-10-2026). Estilos en assets/foucault-conversion.css */
(function () {
  /* A. Descripción de colección: dos líneas + "Leer más" en celular. */
  function recortarDescripcion() {
    var d = document.querySelector('.collection-hero__description');
    if (!d || d.dataset.fcRec) return;
    var p = d.querySelector('p');
    if (!p) return;
    d.dataset.fcRec = '1';
    d.classList.add('fc-recortada');
    if (p.scrollHeight <= p.clientHeight + 2) { d.classList.remove('fc-recortada'); return; }
    var b = document.createElement('button');
    b.type = 'button'; b.className = 'fc-leer-mas'; b.textContent = 'Leer más';
    b.setAttribute('aria-expanded', 'false');
    b.addEventListener('click', function () {
      var abierto = d.classList.toggle('fc-recortada') === false;
      b.textContent = abierto ? 'Leer menos' : 'Leer más';
      b.setAttribute('aria-expanded', abierto ? 'true' : 'false');
    });
    d.appendChild(b);
  }

  /* B. "Ver más relojes": carga la página siguiente debajo, sin recargar.
        La paginación original queda en el HTML (Google la sigue) y vuelve si falla el script. */
  function total() {
    var pc = document.getElementById('ProductCount');
    if (pc && pc.dataset.productCount) return parseInt(pc.dataset.productCount, 10) || 0;
    var t = document.querySelector('#ProductCountDesktop, .product-count__text');
    var m = t && t.textContent.replace(/\./g, '').match(/(\d+)/g);
    return m ? parseInt(m[0], 10) : 0; /* "24 de 176 productos" con filtro: el primero es el total filtrado */
  }
  function siguiente(raiz) {
    var arrows = (raiz || document).querySelectorAll('nav.pagination a.pagination__item-arrow');
    for (var i = 0; i < arrows.length; i++) {
      var li = arrows[i].closest('li');
      if (li && !li.nextElementSibling) return arrows[i].getAttribute('href');
    }
    return null;
  }
  function etiqueta() {
    var p = location.pathname;
    if (/^\/search/.test(p)) return 'Ver más resultados';
    if (/accesorio|billetera|cartera|pulsera|lente/.test(p)) return 'Ver más productos';
    return 'Ver más relojes';
  }
  function montarMas() {
    var grid = document.getElementById('product-grid');
    var nav = document.querySelector('nav.pagination');
    if (!grid || !nav || nav.dataset.fcMas) return;
    var url = siguiente();
    if (!url) return;
    nav.dataset.fcMas = '1';
    var cont = nav.closest('.pagination-wrapper') || nav.parentElement;
    cont.classList.add('fc-mas-on');
    var caja = document.createElement('div');
    caja.className = 'fc-mas';
    caja.innerHTML = '<a class="fc-mas__btn" href="' + url + '">' + etiqueta() + '</a><p class="fc-mas__conteo" aria-live="polite"></p><div class="fc-mas__riel" aria-hidden="true"><div class="fc-mas__avance"></div></div>';
    cont.appendChild(caja);
    var btn = caja.querySelector('.fc-mas__btn');
    function conteo() {
      var n = grid.children.length, t = total();
      caja.querySelector('.fc-mas__conteo').textContent = t ? 'Mostrando ' + n + ' de ' + t : '';
      caja.querySelector('.fc-mas__avance').style.width = t ? Math.min(100, Math.round(n / t * 100)) + '%' : '0';
    }
    conteo();
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      var href = btn.getAttribute('href');
      if (!href) return;
      btn.setAttribute('aria-busy', 'true');
      btn.textContent = 'Cargando…';
      fetch(href, { credentials: 'same-origin' }).then(function (r) { return r.text(); }).then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        var nuevos = doc.querySelectorAll('#product-grid > li');
        var primero = null;
        [].forEach.call(nuevos, function (li, i) {
          li.classList.remove('scroll-trigger--offscreen');
          li.style.setProperty('--animation-order', (i % 8) + 1);
          var nodo = document.importNode(li, true);
          grid.appendChild(nodo);
          if (!primero) primero = nodo;
        });
        var prox = siguiente(doc);
        if (prox) {
          btn.setAttribute('href', prox);
          btn.removeAttribute('aria-busy');
          btn.textContent = etiqueta();
        } else {
          btn.remove();
        }
        conteo();
        if (primero) {
          var enlace = primero.querySelector('a');
          if (enlace) enlace.focus({ preventScroll: true });
        }
      }).catch(function () { window.location.href = href; });
    });
  }

  function iniciar() { recortarDescripcion(); montarMas(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();

  /* Al filtrar u ordenar, Dawn reemplaza la grilla: se vuelve a montar el botón. */
  var gc = document.getElementById('ProductGridContainer');
  if (!gc && document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      var g = document.getElementById('ProductGridContainer');
      if (g) new MutationObserver(function () { montarMas(); }).observe(g, { childList: true });
    });
  } else if (gc) {
    new MutationObserver(function () { montarMas(); }).observe(gc, { childList: true });
  }
})();